exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".fadeInUp[data-v-3eb44064],.fadeIn[data-v-3eb44064]{-webkit-animation-duration:.5s;animation-duration:.5s}.modal-card-body p[data-v-3eb44064]{text-align:center}.full[data-v-3eb44064],textarea[data-v-3eb44064]{width:100%}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3eb44064","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/modals/support-form-modal.vue
// module id = 406
// module chunks = 0